<template>
  <div>
    <div class="maintitle">{{ $route.meta.title }}</div>
    <el-divider></el-divider>
    <el-row :gutter="10" class="text-left">
      <el-col :span="6">
        <el-input v-model="keyword" placeholder="请输入员工姓名"></el-input>
      </el-col>
      <el-button @click="searchEmployee">查询</el-button>
    </el-row>
    <el-table :data="list" border>
      <el-table-column prop="name" label="员工"></el-table-column>
      <el-table-column :formatter="formatExcellent" label="优秀"></el-table-column>
      <el-table-column :formatter="formatCrnt" label="当前审批人"></el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button @click="excellent(scope)" type="text">评优</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize"
                   @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :visible.sync="excellentDiv" :show-close="false" :title="title" :close-on-click-modal="false">
      <el-form class="text-left">
        <el-form-item label="优秀类型">
          <el-select v-model="excellentType">
            <el-option v-for="(item,index) in excellentTypeList" :key="index" :label="item.title"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div v-if="notice !== ''" class="text-left margin-bottom text-danger">{{ notice }}</div>
      <el-table :data="templateInfo" border :tree-props="{ children: 'children' }" row-key="id" default-expand-all>
        <el-table-column prop="title" label="考核内容"></el-table-column>
        <el-table-column label="理由">
          <template v-slot="scope">
            <div v-if="scope.row.score!==''">
              <el-input v-if="firstLeader && crntLeader" type="textarea"
                        v-model="scope.row.beizhu" autosize></el-input>
              <span v-else style="white-space: pre-wrap">{{ scope.row.beizhu }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="primary" @click="submitExcellent(2)" v-if="firstLeader && crntLeader">提交</el-button>
        <el-button type="primary" @click="submitExcellent(1)" v-if="firstLeader && crntLeader">暂存</el-button>
        <el-button type="primary" @click="setExcellent(1)" v-if="!firstLeader && crntLeader">通过</el-button>
        <el-button type="danger" @click="setExcellent(2)" v-if="!firstLeader && crntLeader">拒绝</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      keyword: '',
      page: 1,
      total: 0,
      firstLeader: false,
      excellentDiv: false,
      templateInfo: [],
      notice: '',
      title: '',
      allExcellentType: [],
      excellentType: '',
      crntEmployee: '',
      infoStatus: 2,
      infoId: '',
      crntLeader: false
    }
  },
  computed: {
    excellentTypeList() {
      return this.allExcellentType.filter(item => {
        return item.type === this.crntEmployee.type
      })
    }
  },
  methods: {
    searchEmployee() {
      this.page = 1;
      this.getList();
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getList();
    },
    excellent(scope) {
      this.$axios({
        url: this.HOST + '/kaohe/leaderass/getExcellent',
        method: 'post',
        data: {
          uuid: scope.row.uuid
        }
      }).then((res) => {
        if (res.data.status === 1) {
          this.templateInfo = res.data.list;
          this.firstLeader = res.data.firstLeader;
          this.notice = res.data.notice;
          this.title = scope.row.name;
          this.excellentType = res.data.excellentType;
          this.excellentDiv = true;
          this.crntEmployee = scope.row;
          this.infoStatus = res.data.infoStatus
          this.infoId = res.data.infoId
          this.crntLeader = res.data.crntLeader
        }
      })
    },
    formatExcellent(row) {
      const res = this.allExcellentType.filter(item => {
        return item.id === row.excellent;
      })
      return res.length > 0 ? res[0].title : ''
    },
    formatCrnt(row) {
      return row.crnt === 'final' ? '最终评审' : row.crntName
    },
    closeDialog() {
      this.excellentDiv = false;
      this.excellentType = ''
    },
    submitExcellent(status) {
      this.$axios({
        url: this.HOST + '/kaohe/leaderass/saveExcellent',
        method: 'post',
        data: {
          info: this.templateInfo,
          excellentType: this.excellentType,
          uuid: this.crntEmployee.uuid,
          status: status
        }
      }).then((res) => {
        if (res.data.status === 1) {
          this.closeDialog();
          this.getList();
        }
      })
    },
    setExcellent(status) {
      this.$axios({
        url: this.HOST + '/kaohe/leaderass/setExcellent',
        method: 'post',
        data: {
          id: this.infoId,
          status: status
        }
      }).then(res => {
        if (res.data.status === 1) {
          this.excellentDiv = false;
          this.getList()
        }
      })
    },
    getList() {
      this.$axios({
        url: this.HOST + '/kaohe/leaderass/getEmployeeList',
        method: 'post',
        data: {
          keyword: this.keyword,
          page: this.page,
          pagesize: this.pagesize
        }
      }).then((res) => {
        if (res.data.status === 1) {
          this.list = res.data.list.data;
          this.total = res.data.list.total;
        }
      })
    }
  },
  mounted() {
    this.$axios({
      url: this.HOST + '/kaohe/index/getCommonInfo',
      method: 'post',
      data: {
        info: ['excellentType'],
      }
    }).then((res) => {
      if (res.data.status === 1) {
        this.allExcellentType = res.data.excellentType;
      }
    })
    this.getList();
  }
}
</script>